import { useQuery } from "react-query";
import { getEmployeesAssociatedToOffice } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetEmployeesAssociatedToOffice = () => {
  return useQuery(
    "EmployeesAssociatedToOffice",
    getEmployeesAssociatedToOffice,
    {
      refetchOnWindowFocus: false,
    }
  );
};
